import React from 'react';
import { connect } from 'react-redux';
import { Box, Button, Typography, makeStyles } from '@material-ui/core';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import { logoutSSORequest } from 'modules/auth/actions';
import { history } from 'store';
import LoginPage from 'components/LoginPage';
import ApplicationState from 'store/interfaces';
import decoded from 'jwt-decode';
import UserLoginImageContainer from 'components/UserLoginImageContainer';
import { ConfigState } from 'modules/config/interfaces';
import i18n from 'i18n';
import { store } from 'store';
import styles from './styles';

interface TokenObjectProps {
  identity: {
    errors: string[];
    is_sso_user: boolean;
    status: string;
  };
}
interface Props {
  config: ConfigState;
  logoutSSORequest: () => void;
}

const LogoutSSO: React.FC<Props> = ({ config, logoutSSORequest }) => {
  const classes = makeStyles(styles)();
  const [counter, setCounter] = React.useState(15);
  const { auth } = store.getState();

  const accessToken = auth.isAuthenticate?.access_token;

  React.useEffect(() => {
    if (accessToken) {
      const tokenObject: TokenObjectProps | null = decoded(accessToken);

      if (tokenObject?.identity?.is_sso_user) {
        logoutSSORequest();
      }
    }

    const interval = setInterval(() => {
      setCounter((prev) => prev - 1);
    }, 1000);

    const timeout = setTimeout(() => {
      history.push('/');
    }, 15000);

    return () => {
      clearInterval(interval);
      clearTimeout(timeout);
    };
  }, [logoutSSORequest, history]);

  const language = i18n.language || 'pt-BR';

  const descriptionText =
    {
      es: config?.descriptionMfaTextEs,
      'en-US': config?.descriptionMfaTextEn,
      'pt-BR': config?.descriptionMfaTextPtBr,
    }[language] || config?.descriptionMfaTextPtBr;

  const headerText =
    {
      es: config?.headerMfaTextEs,
      'en-US': config?.headerMfaTextEn,
      'pt-BR': config?.headerMfaTextPtBr,
    }[language] || config?.headerMfaTextPtBr;

  return (
    <>
      <LoginPage
        imageWrapper={
          <UserLoginImageContainer
            bgImage={
              config?.defaultBannerOption !== 0 &&
              config?.defaultBannerOption !== null
                ? `/images/defaultImage${config?.defaultBannerOption}.png`
                : config?.imageUrl
            }
            description={descriptionText}
            header={headerText}
            imageColor={config?.imageLoginBackgroundColor}
          />
        }
        logoUrl={config?.logoUrl}
        logoBackgroundColor={config?.logoBackgroundColor}
      >
        <Box className={classes.container}>
          <CheckCircleOutlineIcon className={classes.icon} />
          <Typography variant="h5" className={classes.message}>
            {i18n.t('LOGOUT_SUCCESS_MESSAGE_KEY')}
          </Typography>
          <Typography variant="body1" className={classes.subMessage}>
            {i18n.t('LOGOUT_REDIRECT_MESSAGE_KEY', { count: counter })}
          </Typography>

          <Button
            variant="contained"
            color="primary"
            onClick={() => history.push('/')}
            className={classes.button}
          >
            {i18n.t('GO_TO_LOGIN_KEY')}
          </Button>
        </Box>
      </LoginPage>
    </>
  );
};

const mapStateToProps = ({ config }: ApplicationState) => ({
  config,
});

export default connect(mapStateToProps, {
  logoutSSORequest,
})(LogoutSSO);
